<script>
  import {Bar, mixins} from 'vue-chartjs'
  // import the component - chart you need

  // Extend it
  export default {
    extends: Bar,
    //mixins: [mixins.reactiveProp],
    props: ['positivePointsDailyLabel','positivePointsDailyColor','positivePointsDailyData','positivePointsDailyID'],
    //props: ['chartdata', 'options'],
    data() {
        var _this = this;
        return {
            datacollection: {
                //labels: ['Attendance', 'Help', 'Hafaz Surah', 'Help Teachers', 'Recite Al-Quran', 'June', 'Cleaned Class', 'August', 'Good', 'Quiz'],
                labels: this.positivePointsDailyLabel,
                datasets: [
                    {
                        label: 'Data One',
                        //backgroundColor: ['#f01818',"#5f18f0",'#e818f0',"#18bbf0",'#18f0bb',"#18f064",'#1a4304',"#434204",'#432504',"#93908d"],
                        backgroundColor: this.positivePointsDailyColor,
                        //data: [12, 20, 12, 18, 10, 6, 9, 32, 29, 19]
                        data: this.positivePointsDailyData
                    }
                ]
            },
            options: {
                responsive: false,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom'
                },                
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90
                        }
                    }]
                },
                onClick: function(evt,arr) {
                    var selectedLabelColumn;
                    var selectedLabelColumnTitle;
                    this.getElementsAtEventForMode(evt, "x", 1).forEach(function(item) { selectedLabelColumn = item._index; selectedLabelColumnTitle = item['_model']['label']; 
                    console.log("45 item"); console.log(item['_model']['label']) });
                    //alert("Column " + selectedLabelColumn + " was selected");

                    try{
                        var label = arr[0]['_model'].label  //this line is purely to throw error for empty bar
                        _this.graphClickEvent(evt,arr);
                    }catch(err){
                        _this.viewBarDetails(selectedLabelColumn,selectedLabelColumnTitle)
                    }
            
                }
            }
        }
    },
    methods: {
        graphClickEvent(evt,arr){
            var label = arr[0]['_model'].label
            var index = arr[0]['_index']
            
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_ID',this.positivePointsDailyID[index])
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_NAME',label)
            this.$store.commit('UPDATE_POSITIVE_PERIOD',1)  //1 for Daily
            localStorage.setItem('POSITIVE_BEHAVIOR_ID',this.positivePointsDailyID[index])
            localStorage.setItem('POSITIVE_BEHAVIOR_NAME',label)
            localStorage.setItem('POSITIVE_PERIOD',1)  //1 for Daily

            this.$router.push({
                name: "SchoolSinglePositiveDetails"
            });
        },
        viewBarDetails(index,title){            
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_ID',this.positivePointsDailyID[index])
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_NAME',title)
            this.$store.commit('UPDATE_POSITIVE_PERIOD',1)  //1 for Daily
            localStorage.setItem('POSITIVE_BEHAVIOR_ID',this.positivePointsDailyID[index])
            localStorage.setItem('POSITIVE_BEHAVIOR_NAME',title)
            localStorage.setItem('POSITIVE_PERIOD',1)  //1 for Daily

            this.$router.push({
                name: "SchoolSinglePositiveDetails"
            });
        }
    },
    mounted () {
      // Overwriting base render method with actual data and options
      this.renderChart(this.datacollection, this.options)
      this.$data._chart.destroy(); //we destroy to try clearing the cached chart data inside user's browser
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Charts/LatestPointsDaily.vue